<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sddrcF/images/cover.jpg?1684514755356" alt="This image is the cover for the book Little Birds with Broken Wings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little Birds with Broken Wings
      </h1>
      <p class="bookDescription body article font2">
        <p>"These pages represent the accumulated wisdom of more than thirty years that David Martin has spent as a writer, teacher, editor, and inspiration. Fine Lines (a literary journal) has been his gift to the world, a champion of literacy and lyricism, a 'lighthouse' to countless writers of all ages, from all over the globe, but it is not his only gift. In this collection of his writing, Martin invites us to see the world through his attentive eyes, bearing witness to what endures, what matters: a mother's love, the flicker of a firefly, the mystery of a dream, a beloved teacher, a triumphant student, the power of myth, and most of all, the written word. Inside his vision, readers are shown the richness, challenges, and rewards of the individual's effort to write, as he says, 'my own internal rhythms and play my own tunes.' This book is a song, a gift, in which we can all take pleasure." -Dr. John Price, Department of English, University of Nebraska at Omaha</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Martin
      </h2>
      
      <p class="authorDescription body article">David Martin has spent nearly 40 years as a teacher, writer, and editor. He is the author of two essay collections, Little Birds with Broken Wings (WriteLife, 2012); and Facing the Blank Page (WriteLife, 2009). Martin is the editor of the quarterly litera</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BQB Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2efbcc58